var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.userHasPermissions("provider.specialist.license.view")
    ? _c(
        "div",
        [
          _c("section-title", {
            attrs: { content: "Información de Licencia(s)", "has-line": true }
          }),
          _vm.activateSpecialistLicenseFilterByHealthDepartment
            ? _c("p", { staticClass: "text-gray" }, [
                _c("em", { staticClass: "far fa-info-circle mr-1" }),
                _vm._v(
                  " Las licencias correspondientes al Departamento de Salud, deben ser agregadas mediante la acción Consultar DS "
                )
              ])
            : _vm._e(),
          _vm.licensesData && _vm.licensesData.length > 0
            ? _c(
                "div",
                { staticClass: "license-information-list mt-3" },
                [
                  _vm._l(_vm.orderedLinceses, function(license, idx) {
                    return [
                      (idx >= _vm.pageStartIndex) & (idx < _vm.pageEndIndex)
                        ? _c(
                            "callout",
                            {
                              key:
                                license.specialistLicenseId || license.tempId,
                              staticClass: "mb-2",
                              attrs: {
                                "has-toggle": false,
                                opened: !_vm.disabled && _vm.editMode
                              },
                              scopedSlots: _vm._u(
                                [
                                  _vm.editMode && _vm.editIndex == idx
                                    ? {
                                        key: "edition",
                                        fn: function() {
                                          return [
                                            _c("license-information-add-edit", {
                                              attrs: {
                                                "custom-error-message":
                                                  _vm.addEditCustomErrorMessage,
                                                "immediate-save":
                                                  _vm.immediateSave,
                                                "is-related-master":
                                                  _vm.isRelatedMaster,
                                                "op-mode": "E",
                                                "selected-licenses":
                                                  _vm.licensesData,
                                                "specialist-id":
                                                  _vm.specialistId,
                                                "specialist-license-document-types":
                                                  _vm.specialistLicenseDocumentTypes
                                              },
                                              on: {
                                                "on-cancel":
                                                  _vm.clearEditCreate,
                                                "on-saved":
                                                  _vm.emitLicenseChange
                                              },
                                              model: {
                                                value: _vm.licensesData[idx],
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.licensesData,
                                                    idx,
                                                    $$v
                                                  )
                                                },
                                                expression: "licensesData[idx]"
                                              }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    : null
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _c("div", { staticClass: "row mt-2 mb-2" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-sm-12 col-md-3 col-lg-2 cell"
                                  },
                                  [
                                    _c("div", { staticClass: "data" }, [
                                      _c("span", [_vm._v("Especialidad:")]),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(license.specialtyTypeName)
                                        )
                                      ])
                                    ])
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-sm-12 col-md-3 col-lg-1 cell"
                                  },
                                  [
                                    _vm.hasDetails(license.specialtyTypeId)
                                      ? _c("div", { staticClass: "data" }, [
                                          _c("span", [
                                            _vm._v("Número de Licencia:")
                                          ]),
                                          _c("p", [
                                            _vm._v(_vm._s(license.licenseNo))
                                          ])
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-sm-12 col-md-1 col-lg-1 cell"
                                  },
                                  [
                                    _vm.hasDetails(license.specialtyTypeId)
                                      ? _c("div", { staticClass: "data" }, [
                                          _c("span", [
                                            _vm._v("Fecha de Expiración:")
                                          ]),
                                          _c(
                                            "p",
                                            {
                                              class: _vm.getClassExpiration(
                                                license.licenseExpireDate
                                              )
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("date")(
                                                      license.licenseExpireDate
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _vm.hasDetails(license.specialtyTypeId)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-sm-12 col-md-1 col-lg-1 cell"
                                      },
                                      [
                                        _c("div", { staticClass: "data" }, [
                                          _c("span", [
                                            _vm._v("Tipo de Licencia:")
                                          ]),
                                          _c("p", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  license.specialtyTypeNameHd
                                                    ? "SALUD"
                                                    : "MIPE"
                                                ) +
                                                " "
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.hasDetails(license.specialtyTypeId)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-sm-12 col-md-1 col-lg-1 cell"
                                      },
                                      [
                                        _c("div", { staticClass: "data" }, [
                                          _c("span", [_vm._v("Estatus:")]),
                                          _c("p", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  license.specialtyTypeNameHd &&
                                                    !license.isFromHd
                                                    ? "Pendiente"
                                                    : "Validada"
                                                ) +
                                                " "
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-sm-12 col-md-1 col-lg-2 cell"
                                  },
                                  [
                                    license.supervisorFlag
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "data d-inline-block"
                                          },
                                          [
                                            _c("custom-balloon", {
                                              staticClass:
                                                "mt-2 pl-2 pr-2 font-weight-normal font-16",
                                              attrs: {
                                                "background-color": "gray",
                                                text: "Supervisor"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    license.provisionalFlag
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "data d-inline-block"
                                          },
                                          [
                                            _c("custom-balloon", {
                                              staticClass:
                                                "mt-2 pl-2 pr-2 font-weight-normal font-16",
                                              attrs: {
                                                "background-color": "gray",
                                                text: "Provisional"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                !_vm.disabled && _vm.canPerformActions
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-sm-12 col-md-1 col-lg-2 cell actions"
                                      },
                                      [
                                        _c("drop-down", {
                                          staticClass: "float-right",
                                          attrs: {
                                            "data-item": idx,
                                            items: _vm.getAvailableActions()
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  }),
                  !_vm.disabled
                    ? _c("div", { staticClass: "row mt-3" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            !_vm.editMode && _vm.canAddLicense
                              ? _c(
                                  "action-button",
                                  {
                                    staticClass: "float-right",
                                    attrs: {
                                      i: "fas fa-file-plus",
                                      variant: "success"
                                    },
                                    on: { click: _vm.onAdd }
                                  },
                                  [_vm._v(" Añadir ")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        this.pagingInfo.totalItemCount > 5
                          ? _c("pagination", {
                              staticClass: "mb-3",
                              attrs: {
                                data: this.pagingInfo,
                                "show-text": true
                              },
                              on: { "pagination-go-page": _vm.setCurrentPage }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ],
                2
              )
            : _c(
                "div",
                { staticClass: "license-information-list mt-3" },
                [
                  _vm.licensesData.length == 0 &&
                  _vm.canAddLicense &&
                  !_vm.createMode &&
                  !_vm.editMode &&
                  !_vm.disabled
                    ? _c(
                        "callout",
                        {
                          attrs: { "class-main": "py-3", "has-toggle": false }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "row d-flex justify-content-center"
                            },
                            [
                              _c("action-button", {
                                staticClass: "border w-40 btn",
                                attrs: {
                                  i: "fas fa-file-plus color-primary-1",
                                  text: "Presione aquí para añadir Licencia(s)"
                                },
                                on: { click: _vm.onAdd }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
          _c("callout", {
            staticClass: "mb-2",
            attrs: {
              opened: !_vm.disabled && _vm.createMode,
              "show-container": false
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "edition",
                  fn: function() {
                    return [
                      _c("license-information-add-edit", {
                        attrs: {
                          "activate-specialist-license-filter-by-health-department":
                            _vm.activateSpecialistLicenseFilterByHealthDepartment,
                          "custom-error-message": _vm.addEditCustomErrorMessage,
                          "immediate-save": _vm.immediateSave,
                          "is-a-t-evaluator": _vm.isATEvaluator,
                          "is-csee-official": _vm.isCseeOfficial,
                          "is-related-master": _vm.isRelatedMaster,
                          "op-mode": "I",
                          "selected-licenses": _vm.licensesData,
                          "specialist-company-id": _vm.specialistCompanyId,
                          "specialist-id": _vm.specialistId,
                          "specialist-license-document-types":
                            _vm.specialistLicenseDocumentTypes
                        },
                        on: {
                          "on-cancel": _vm.clearEditCreate,
                          "on-saved": _vm.onLicenseAdded
                        },
                        model: {
                          value: _vm.newLicense,
                          callback: function($$v) {
                            _vm.newLicense = $$v
                          },
                          expression: "newLicense"
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3503118856
            )
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }